module.exports = __webpack_public_path__ + "./images/Others.cd7f65.jpg";